// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".report-chevron-icon,.report-pdf-icon{color:#ef4a81;color:var(--is-primary-primary,#ef4a81);margin-left:-5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
